/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Company_AboutInputs */

const de_commons_footer_company_about = /** @type {(inputs: Commons_Footer_Company_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über uns`)
};

/** @type {(inputs: Commons_Footer_Company_AboutInputs) => LocalizedString} */
const en_commons_footer_company_about = de_commons_footer_company_about;

/**

* @param {Commons_Footer_Company_AboutInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_company_about = /** @type {((inputs?: Commons_Footer_Company_AboutInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Company_AboutInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_company_about(inputs)
	return en_commons_footer_company_about(inputs)
});